import { ReduxState } from '../types';

export const getUserSubId = (state: ReduxState): string =>
  state.auth.getIn(['userSubId']) as string;

export const getUserEmail = (state: ReduxState): string =>
  state.auth.getIn(['attributes', 'email']) as string;
